/**
 * displays the image rights dialogue on right click of an image
 * and hides it on click of the dialogue button
 */

const toggleImageRights = () => {
	const dialogue = document.getElementById('image-rights');
	const dialogueButton = dialogue.lastElementChild;

	const toggleVisibility = (el) => {
		el.classList.toggle('hidden');
	}

	const getCursorPosition = (event) => {
		const dialogueWidth = dialogue.clientWidth / 2;
		const dialogueHeight = dialogue.clientHeight / 2;
		const horizontal = event.pageX - dialogueWidth;
		const vertical = event.pageY - dialogueHeight;
		return {x: `${horizontal}px`, y: `${vertical}px`};
	}

	const setDialoguePosition = (event) => {
		const position = getCursorPosition(event);
		dialogue.style.transform = `translateX(${position.x}) translateY(${position.y})`;
	}
	
	const handleRightClick = (event) => {
		const isImage = event.target.tagName === "IMG";
		if (isImage) {
			event.preventDefault();
			toggleVisibility(dialogue);
			setDialoguePosition(event);
		}
	}

	const handleDialogueBtnClick = () => {
		toggleVisibility(dialogue);
	}

	document.addEventListener('contextmenu', handleRightClick);
	dialogueButton.addEventListener('click', handleDialogueBtnClick);
}

export default toggleImageRights;